import { render, staticRenderFns } from "./RecomDesignedToCard.vue?vue&type=template&id=547cc53e"
import script from "./RecomDesignedToCard.vue?vue&type=script&lang=js"
export * from "./RecomDesignedToCard.vue?vue&type=script&lang=js"
import style0 from "./RecomDesignedToCard.vue?vue&type=style&index=0&id=547cc53e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports